import React from "react";
import "react-datetime/css/react-datetime.css";
import "./scheduleStyle.css"; // Keep for non-alignment styles (e.g., colors)
import CustomDateTimePicker from "../../DateTimePicker/dateTimePicker";
import moment from "moment";
import FormInput from "../Input/formInput"; // Adjust path as needed

const ScheduleDay = ({ schedule, dayIndex, handleScheduleChange, handleAddTimeSlot, handleDeleteTimeSlot, toggleDayChecked, isProfilePage = false }) => {
    const isDisabled = !schedule.checked;

    return (
        <div>
            {schedule.timeSlots.map((slot, slotIndex) => (
                <div
                    className={`row d-flex align-items-center mb-3 ${isProfilePage ? "gx-3" : ""}`}
                    key={slotIndex}
                >
                    {/* Checkbox (Only for First Slot) */}
                    <div className="col-2 d-flex align-items-center">
                        {slotIndex === 0 && (
                            <div className="form-check d-flex align-items-center">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={schedule.checked}
                                    onChange={(e) => toggleDayChecked(dayIndex, e.target.checked)}
                                />
                                <label className="form-check-label ms-2 fw-bold">{schedule.day}</label>
                            </div>
                        )}
                    </div>

                    {/* Description Input (Profile Page Only) */}
                    {isProfilePage && (
                        <div className="col-3 d-flex align-items-center">
                            <FormInput
                                placeHolder="Service Name"
                                type="text"
                                value={slot.description || ""}
                                onchange={(e) => handleScheduleChange(dayIndex, slotIndex, "description", e.target.value)}
                                width="100%"
                                className="form-control"
                            />
                        </div>
                    )}

                    {/* Start Time */}
                    <div className={isProfilePage ? "col-2 d-flex align-items-center" : "col-3 d-flex align-items-center"}>
                        <CustomDateTimePicker
                            label="Start Time"
                            value={slot.from ? moment(slot.from, "HH:mm") : null}
                            mode="time"
                            onChange={(time) => handleScheduleChange(dayIndex, slotIndex, "from", time)}
                            ampm={true}
                            disabled={isDisabled}
                            placeholder="Select time"
                        />
                    </div>

                    {/* "to" Label */}
                    <div className="col-1 d-flex align-items-center justify-content-center">
                        <span className={isProfilePage ? "fw-bold" : ""}>to</span>
                    </div>

                    {/* End Time */}
                    <div className={isProfilePage ? "col-2 d-flex align-items-center" : "col-3 d-flex align-items-center"}>
                        <CustomDateTimePicker
                            label="End Time"
                            value={slot.to ? moment(slot.to, "HH:mm") : null}
                            mode="time"
                            onChange={(time) => handleScheduleChange(dayIndex, slotIndex, "to", time)}
                            ampm={true}
                            disabled={isDisabled}
                            placeholder="Select time"
                        />
                    </div>

                    {/* Delete Button (Not for First Slot) */}
                    <div className="col-1 d-flex align-items-center justify-content-center">
                        {slotIndex > 0 && (
                            <button
                                className="btn btn-link p-0 text-danger"
                                onClick={() => handleDeleteTimeSlot(dayIndex, slotIndex)}
                                disabled={isDisabled}
                            >
                                <i className="fa fa-times"></i>
                            </button>
                        )}
                    </div>

                    {/* Add Button (Only for Last Slot) */}
                    <div className="col-1 d-flex align-items-center justify-content-center">
                        {slotIndex === schedule.timeSlots.length - 1 && (
                            <button
                                className="btn btn-link p-0 text-primary"
                                onClick={() => handleAddTimeSlot(dayIndex)}
                                disabled={isDisabled}
                            >
                                <span className="icon-plus text-primary"></span>
                            </button>
                        )}
                    </div>
                </div>
            ))}
            <hr className="mb-3" />
        </div>
    );
};

const ScheduleManager = ({ schedules, setSchedules, isProfilePage = false }) => {
    const handleScheduleChange = (dayIndex, slotIndex, field, value) => {
        const updatedSchedules = [...schedules];
        const formattedValue = field === "description" ? value : moment.isMoment(value) ? value.format("HH:mm") : value;
        updatedSchedules[dayIndex].timeSlots[slotIndex][field] = formattedValue;
        setSchedules(updatedSchedules);
    };

    const handleAddTimeSlot = (dayIndex) => {
        const updatedSchedules = [...schedules];
        updatedSchedules[dayIndex].timeSlots.push({ from: "", to: "", description: "" });
        setSchedules(updatedSchedules);
    };

    const handleDeleteTimeSlot = (dayIndex, slotIndex) => {
        const updatedSchedules = [...schedules];
        if (updatedSchedules[dayIndex].timeSlots.length > 1) {
            updatedSchedules[dayIndex].timeSlots.splice(slotIndex, 1);
            setSchedules(updatedSchedules);
        }
    };

    const toggleDayChecked = (dayIndex, checked) => {
        const updatedSchedules = [...schedules];
        updatedSchedules[dayIndex].checked = checked;
        setSchedules(updatedSchedules);
    };

    return (
        <div>
            {schedules.map((schedule, dayIndex) => (
                <ScheduleDay
                    key={dayIndex}
                    schedule={schedule}
                    dayIndex={dayIndex}
                    handleScheduleChange={handleScheduleChange}
                    handleAddTimeSlot={handleAddTimeSlot}
                    handleDeleteTimeSlot={handleDeleteTimeSlot}
                    toggleDayChecked={toggleDayChecked}
                    isProfilePage={isProfilePage}
                />
            ))}
        </div>
    );
};

export default ScheduleManager;